import React from 'react';
import ReactDOM from 'react-dom';
import * as PIXI from 'pixi.js'

class ToReact extends React.Component {
  componentDidMount() {
    const container = ReactDOM.findDOMNode(this);
    container.appendChild(this.props.data);
  }

  render() {
    return (<div className="ToReact"/>);
  }
}

class Watermelon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      app: new PIXI.Application({width: 300, height: 700})
    }

    let app = this.state.app;

    let cat, state;

    let loader = new PIXI.Loader("",10)
    loader
    .add("/sprites/animals.json")
    .load(setup);
    
    function setup() {

      let id = loader.resources["/sprites/animals.json"].textures;

      cat = new PIXI.Sprite(id["cat.png"]);
      cat.anchor.set(.5, .5);
      cat.x = 150;
      cat.y = 100;
      cat.vx = 0;
      cat.vy = 0;
      app.stage.addChild(cat);

      state = play;
      app.ticker.add( delta => gameLoop(delta) );
    }
    function gameLoop(delta) {
      state(delta);
    }
    function play(delta) {
      let t = 1;
      cat.vy += .5 * t;

      cat.x += t * cat.vx;
      cat.y += t * cat.vy;

      cat.vy += .5 * t;

      if (cat.y  >= 400) {
        cat.vy -= t;
        cat.vy = -.8 * cat.vy;
      }
      if (cat.y  > 400) {
        cat.y = 400;
      }
    }
  }
  
  render() {
    return (<ToReact data={this.state.app.view}/>);
  }
}

export default Watermelon;
